//
// MapChartOperations.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./ControllerOperations";
import "@sas-dvr/ltjs-commons/maps/MapSearchResult";
import "./DragMode";
import "./LocationOperations";

var MapChartOperations = createModule("gtl::MapChartOperations", ["gtl::ControllerOperations"], EventDispatcher, [
    {
        MAP_PROVIDER_CHANGED: 30063,
        REVERSE_GEOCODE_COMPLETE: 30066,
        CURRENT_SEARCH_MARKER_SELECTED: 30060,
        MAP_VIEW_CHANGING: 30064,
        SEARCH_HINTS_READY: 30067,
        PINS_UPDATED: 30070,
        ESRI_DRIVETIME_COMPLETE: 30068,
        ESRI_GEO_ENRICHMENT_COMPLETE: 30069,
        PIN_SELECTED: 30061,
        MAP_BOUNDS_CHANGED: 30062,
        SEARCH_COMPLETE: 30065,
        LOCATION_UPDATED: 30071,
    },
    ,
    ,
    {
        esriPremiumToken: 7,
    },
    {
        getDragMode: [4],
        getLocationOperations: [1],
        pointInsideSelectionPolygon: [2,11],
        reverseGeocode: [0,11,2],
        shouldInstallBrushController: [2],
        setWebMapConstraints: [0,1],
        hasSelection: [2],
        getProjectedBounds: [12],
        zoom: [0,5],
        getReverseGeocodeResult: [1],
        getMapDataBounds: [12],
        canDoDistanceSelections: [2],
        setViewport: [0,12,2],
        listenForLocation: [0,2],
        canZoomIn: [2],
        cancelReverseGeocode: [0],
        canZoomOut: [2],
        getMapBounds: [12],
        resetView: [0],
        setShouldInstallBrushController: [0,2],
        convertPixelToLatLon: [11,11],
        setVisualStyleOverride: [0,2],
        getViewSize: [13,4],
        clearSelections: [0],
    },
    ,
    ,
]);
export default MapChartOperations;
